export const filterFalsyValues = (value) => {
  return Object.keys(value)
    .filter((key) => value[key]) // Remove keys with false values
    .reduce((obj, key) => {
      obj[key] = value[key];
      return obj;
    }, {});
};
